import { render, staticRenderFns } from "./MiniLoader.vue?vue&type=template&id=220d5901&scoped=true&"
import script from "./MiniLoader.vue?vue&type=script&lang=js&"
export * from "./MiniLoader.vue?vue&type=script&lang=js&"
import style0 from "./MiniLoader.vue?vue&type=style&index=0&id=220d5901&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d5901",
  null
  
)

export default component.exports